<app-stages [stages]='stages' currentStage='Dane identyfikacyjne'>
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete='off' [formGroup]='form' (ngSubmit)="submitAndGoNext()">
    <br>
    <div class='row'>
      <div class='col-12'>
        <div class='form-group' *ngIf='"isFiledByProxy" as controlName'>
          <div class='custom-checkbox custom-inline'
               [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              (change)="form.isFiledByProxyChange()"
              [formControlName]='controlName'
              type='checkbox'
              [id]='controlName'
              [name]='controlName'>
            <label [for]='controlName'>
              Składam wniosek przez pełnomocnika
            </label>
          </div>
          <app-validation-errors [control]='form.isFiledByProxy'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    @if (form.isFiledByProxy.value) {
      <app-proxy-form [form]='form.proxyPersonForm'>
      </app-proxy-form>
      <br>
    }
    <div class='form-actions top flex-column flex-md-row' *ngIf="!form.isFiledByProxy.value">
      <button type='button' class='btn btn-secondary' (click)='onPastDataFromLoginGov()'>
        <i class='fa fa-paste' aria-hidden='true'></i>
        Wczytaj dane z Profilu zaufanego
      </button>
      <button type='button' class='btn btn-secondary' (click)='onPastDataFromPortal()'>
        <i class='fa fa-paste' aria-hidden='true'></i>
        Wczytaj dane z Portalu e-usług
      </button>
    </div>
    <fieldset>
      <legend>
        Dane identyfikacyjne
      </legend>
      <div class="row" *ngIf="form as form" [formGroup]="form">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"pesel" as controlName'>
            <label [for]='controlName'>
              Numer PESEL *
            </label>
            <input
              mask="00000000000"
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu numer PESEL'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"firstName" as controlName'>
            <label [for]='controlName'>
              Imię/Imiona *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu imię/imiona'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"lastName" as controlName'>
            <label [for]='controlName'>
              Nazwisko *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwisko'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Adres zamieszkania
      </legend>
      <app-applicant-address-data-form [form]="form">
      </app-applicant-address-data-form>
    </fieldset>
    <fieldset>
      <legend>
        Kontakt
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"phone" as controlName'>
            <label [for]='controlName'>
              Numer telefonu
            </label>
            <input
              mask='0*'
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu dodatkowy numer telefonu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"email" as controlName'>
            <label [for]='controlName'>
              E-mail
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu e-mail'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      @if (!uiSettings()?.mobileEmbed) {
        <button
          type='button'
          class='btn btn-secondary'
          (click)='onCancel()'>
        <span>
          Wstecz
        </span>
        </button>
      }
      <button
        [disabled]='!serviceType() || pending()'
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
